<script setup>
import { computed } from "vue";

const props = defineProps({
  id: Number,
});

const TERMINOLOGY = {
  1: "ha1",
  2: "ha2",
  4: "va",
  5: "hna",
};

const terminologyLabel = computed(() => TERMINOLOGY[props.id]);
</script>

<template>
  <div class="tag-nomenclature" :class="terminologyLabel">
    {{ terminologyLabel }}
  </div>
</template>

<style scoped lang="scss">
@use "../../../assets/css/theme/helpers/variables";

.tag-nomenclature {
  display: inline-flex;
  padding: 2px 6px;
  justify-content: center;
  align-items: center;
  gap: 10px;
  border-radius: 4px;
  height: fit-content;

  color: var(--com-text--dark);
  font-size: 10px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  letter-spacing: 0.3px;
  text-transform: uppercase;

  @each $class,
    $color
      in (
        ha1: variables.$tag-bg-ha1,
        ha2: variables.$tag-bg-ha2,
        va: variables.$tag-bg-va,
        hna: variables.$tag-bg-hna
      )
  {
    &.#{$class} {
      background: $color;
    }
  }
}
</style>
